import React from 'react';
import sprintf from 'sprintf';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import 'react-mdl/extra/material.js';
import {Textfield, Checkbox} from 'react-mdl';
import SMRailsBridge from 'lib/SMRailsBridge.js.erb';
import SMTrackHelper from 'components/helpers/SMTrackHelper';

class SMSignUpView extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      resource: this.props.resource,
      resource_name: this.props.resource_name,
      errors: this.props.errors,
      authenticity_token: this.props.authenticity_token,
    };

    this.fileDidUpload = this.fileDidUpload.bind(this);
    this.facebookLoginHandler = this.facebookLoginHandler.bind(this);
  }

  componentDidMount() {
  }

  renderErrorMessage(type) {
    let dict = {
      family_name: I18n.t("service.label_000078"),
      given_name: I18n.t("service.label_000079"),
      email: I18n.t("service.label_000500"),
      password: I18n.t("service.label_000501"),
      password_confirmation: I18n.t("service.label_000505"),
      accept_term_of_service: I18n.t("service.label_000019"),
    };

    if (this.state.errors[type]) {
      let message = dict[type] + this.state.errors[type];
      return (
        <p className="signup-box__required"><i className="fa fa-exclamation-circle" />{message}</p>
      );
    }
  }

  fileDidUpload(e) {
    if (e.currentTarget.files && !e.currentTarget.files.length) return;
    let file = e.currentTarget.files[0],
      fileReader = new FileReader();
    let $fileInput = $(this.refs.profile_image);
    fileReader.onload = (e)=> {
      this.setState({
        profileImage: e.target.result
      });
    };
    fileReader.readAsDataURL(file);
  }

  trackPageEvent(label) {
    SMTrackHelper.pageEvent(label);
  }

  setFacebookLoginFlag() {
    sessionStorage.facebookLoginFlag = 1;
  }

  facebookLoginHandler() {
    this.setFacebookLoginFlag();
    this.trackPageEvent('account sign_in facebook');
  }

  renderReferrerCorpname() {
    if (this.props.referrer_corpname != null && this.props.referrer_corpname.length != 0) {
      const referrer_corpname = `（${this.props.referrer_corpname}）`;
      return (
        <span className="signup-referral__company-name">{referrer_corpname}</span>
      );
    }
  }

  renderReferralHeader() {
    if (this.props.referrer_name != null && this.props.referrer_name.length != 0) {
      return (
        <div className="mod-heroimg signup-referral__bg">
          <img src={SMRailsBridge.assetPath.referralHeroManyspace} alt="友だち招待" className="mod-heroimg__img" />
          <div className="mod-heroimg__bg signup-referral__bg">
            <h1 className="mod-heroimg__title signup-referral__title">
              <img src={this.props.referrer_image} alt="招待者" className="signup-referral__subscriber-img" />
              {this.props.referrer_name}さん{this.renderReferrerCorpname()}から<br />招待が届きました
              <span className="signup-referral__ribbon">
                <span className="signup-referral__ribbon-inner" >2,000ポイントプレゼント</span>
              </span>
              <span className="signup-referral__subtitle">
                下記よりアカウント登録をすると受け取れます。<br className="pc-hide__sm-show" />さっそく登録しよう。
              </span>
            </h1>
          </div>
        </div>
      );
    }
  }

  renderProfileImage() {
    if (this.state.profileImage) {
      let style = {backgroundImage: "url(" + this.state.profileImage + ")"};

      return (
        <span className="settings-img__change-img" style={style}>
          <label htmlFor="files" className="button-gray settings-img">
            <span className="icon-ll"><i className="fa fa-camera" /></span><br />{I18n.t('dashboard.label_000055')}
          </label>
        </span>
      );
    } else {
      return (
        <label htmlFor="files" className="button-gray settings-img">
          <span className="icon-ll"><i className="fa fa-camera" /></span><br />{I18n.t('dashboard.label_000117')}
        </label>
      );
    }
  }

  render() {

    return (
      <div className="site-main">
        {this.renderReferralHeader()}
        <div className="page__even lp-page__padding">
          <div className="page__col1">
            <div className="signup-head">
              <h1 className="page-title">{I18n.t("service.label_000080")}</h1>
              <ul className="signup-step mb20">
                <li className="signup-step__status1 is-current">{I18n.t("service.label_000027")}</li>
                <li className="signup-step__status3">{I18n.t("service.label_000099")}</li>
                <li className="signup-step__status2"><span className="sm-hide">{I18n.t("service.label_000081")}</span>{I18n.t("service.label_000082")}</li>
              </ul>
            </div>
            <div className="signup-box">
              <div className="row">
                <div className="col-xs-12">
                  <h2 className="signup-box__title">{I18n.t("service.label_000083")}</h2>
                  <div className="signup-box__wrapper">
                    <div className="signup-box__wrapper-fb">
                      <a href={Routes.user_omniauth_authorize_path('facebook')} className="button-facebook pt15 pb15 w100pa" onClick={this.facebookLoginHandler}><span className="signup-box__sns-button">{I18n.t("service.label_000084")}</span></a>
                    </div>
                    <p className="signup-box__notes ta-c">{I18n.t("service.text_000015")}<br className="sm-hide" />{I18n.t("service.text_000016")}<br className="sm-hide" />
                      <a href={Routes.terms_about_index_path()} className="a__underline">{I18n.t("service.label_000019")}</a>{I18n.t("service.text_000017")}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="signup-box">
              <div className="row">
                <div className="col-xs-12">
                  <h2 className="signup-box__title">{I18n.t("service.label_000085")}</h2>
                  <div className="signup-box__wrapper-form">
                    <div className="row signup-box__md-top">
                      <form ref="form" action={Routes.user_registration_path()} method="post" encType="multipart/form-data" acceptCharset="UTF-8">
                      <input name="utf8" type="hidden" value="✓" />
                      <input type="hidden" name='authenticity_token' value={this.state.authenticity_token} />
                      <input type="hidden" value="0" name="user[registration_type]" id="user_registration_type" />
                      <div className="col-sm-12 col-md-6">
                        <Textfield
                          className="w100pa"
                          id="family_name"
                          name="user[family_name]"
                          defaultValue={this.props.family_name}
                          label={I18n.t("service.label_000078")}
                          floatingLabel
                        />
                        {this.renderErrorMessage('family_name')}
                      </div>
                      <div className="col-sm-12 col-md-6">
                        <Textfield
                          className="w100pa"
                          id="given_name"
                          name="user[given_name]"
                          defaultValue={this.props.given_name}
                          label={I18n.t("service.label_000079")}
                          floatingLabel
                        />
                        {this.renderErrorMessage('given_name')}
                      </div>
                      <div className="col-sm-12">
                        <Textfield
                          className="w100pa"
                          id="mail"
                          name="user[email]"
                          defaultValue={this.props.email}
                          label={I18n.t("service.label_000500")}
                          floatingLabel
                        />
                        {this.renderErrorMessage('email')}
                      </div>
                      <div className="col-sm-12">
                        <Textfield
                          type="password"
                          className="w100pa"
                          id="password"
                          name="user[password]"
                          label={I18n.t("service.label_000501")}
                          floatingLabel
                        />
                        {this.renderErrorMessage('password')}
                      </div>
                      <div className="col-sm-12">
                        <Textfield
                          type="password"
                          className="w100pa"
                          id="password2"
                          name="user[password_confirmation]"
                          label={I18n.t("service.label_000505")}
                          floatingLabel
                        />
                        {this.renderErrorMessage('password_confirmation')}

                      </div>
                      <div className="col-xs-12">
                        <div className="signup-box__wrapper-form-profile clearfix">
                          <label htmlFor="files" className="signup-box__wrapper-form-title fl">{I18n.t("service.label_000086")}</label>
                          <input ref="profile_image" onChange={this.fileDidUpload} type="file" name="user[profile_image]" id="files" hidden />
                          <div className="signup-box__wrapper-form-profile__img">
                            <div className="settings-img__change-img">
                              {this.renderProfileImage()}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-12">
                        <p className="signup-box__wrapper-form-notes">{I18n.t("service.label_000087")}<a href={Routes.terms_about_index_path()} className="a__underline">{I18n.t("service.label_000019")}</a>{I18n.t("service.label_000088")}</p>
                        <input name="user[accept_term_of_service]" type="hidden" value="0" />
                        <Checkbox
                          id="checkbox-1"
                          ref="checkbox"
                          name="user[accept_term_of_service]"
                          label={I18n.t("service.label_000089")}
                          value="1"
                          defaultChecked={this.props.accept_term_of_service == 1}
                        />
                        {this.renderErrorMessage('accept_term_of_service')}
                      </div>
                      <div className="col-sm-12 ta-c">
                        <input type="submit" name="commit" value={I18n.t("service.label_000102")} className="button-blue mt20 pt15 pb15 w300 sm-w100" />
                      </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="signup-box">
              <div className="row">
                <div className="col-xs-12 ta-c">
                  <h2 className="signup-box__title signup-box__title-other">{I18n.t("service.label_000090")}<br className="pc-hide__sm-show" />{I18n.t("service.label_000100")}</h2>
                  <a href={Routes.new_user_session_path()} className="button-blue pt15 pb15 w200 sm-w100">{I18n.t("service.label_000026")}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      );
    }
  }
  export default SMSignUpView;



// WEBPACK FOOTER //
// ./app/javascript/components/sessions/SMSignUpView.jsx